<div class="logout-modal fadeIn animated">
  <div class="modal-header">
    <h2 class="cl-black">¿Deseas cerrar tu sesión?</h2>
  </div>

  <p class="subtitle">
    Tu sesión en Monific protege tus inversiones.
  </p>

  <hr />

  <ul class="info-list fs-14">
    <li class="m-0">Si terminaste, puedes salir con seguridad.</li>
    <li class="m-0">Si aún estás revisando proyectos, presiona Cancelar.</li>
  </ul>

  <div class="modal-actions">
    <button class="btn btn-primary" (click)="logout()">Cerrar sesión</button>
    <button class="btn btn-secondary" (click)="cancel()">Cancelar</button>
  </div>
</div>